import { StoreApi, UseBoundStore } from "zustand";
import { WithSelectors } from "./types";

const hasActions = (actions: {
  [key: string]: any;
}): actions is { [key: string]: any } => Object.keys(actions).length !== 0;

export const createSelectors = <S extends UseBoundStore<StoreApi<object>>>(
  _store: S
) => {
  let store = _store as WithSelectors<S>;
  store.use = {} as any;
  store.use.actions = {} as any;

  const state = store.getState();

  for (const key of Object.keys(state)) {
    if (key === "actions") {
      for (const nestedKey of Object.keys((state as any).actions)) {
        (store.use as any).actions[nestedKey] = () =>
          store((s) => (s as any).actions[nestedKey]);
      }
    } else {
      (store.use as any)[key] = () => store((s) => (s as any)[key]);
    }
  }

  if (!hasActions(store.use.actions)) {
    delete (store.use as any).actions;
  }

  return store;
};
